// @ts-nocheck

import React, { useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled, { css, keyframes } from 'styled-components';

import { Target } from '../../../client';
import SpinePlayer from '../../../components/SpinePlayer';
import { OverlaySoundIdByAnimationId } from '../../../constants/overlay';
import { SpineAnimationId } from '../../../types/animations';

const APPEARANCE_TRANSITION_DURATION = 300;

const appearAnim = keyframes`
  0% {
    opacity: 0;
    pointer-events: none;
  }
  100% {
    opacity: 1;
    pointer-events: auto;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  top: constant(safe-area-inset-top);
  top: env(safe-area-inset-top);
  width: 100vw;
  z-index: 9999999;
  pointer-events: none;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $isMobile }) =>
    $isMobile
      ? css`
          height: 60vh;
          transform: scale(1.6);
        `
      : css`
          height: 100vh;
        `}

  &.overlay-animation-transitions-enter {
    animation: ${appearAnim} ${APPEARANCE_TRANSITION_DURATION}ms ease-out forwards;
  }

  &.overlay-animation-transitions-exit {
    animation: ${appearAnim} ${APPEARANCE_TRANSITION_DURATION}ms ease-out forwards reverse;
  }
`;

const SpinePlayerWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 750px;
`;

const StyledSpineSplayer = styled(SpinePlayer)`
  position: relative;
`;

type OverlayAnimationProps = {
  className?: string;
  animationId: SpineAnimationId;
  endAnimation: () => void;
};

const OverlayAnimation = ({ className, animationId, endAnimation }: OverlayAnimationProps) => {
  const soundId = useMemo(() => OverlaySoundIdByAnimationId[animationId], [animationId]);

  return (
    <CSSTransition
      classNames="overlay-animation-transitions"
      in={!!(animationId && soundId)}
      timeout={APPEARANCE_TRANSITION_DURATION}
      unmountOnExit
      mountOnEnter
    >
      <Wrapper className={className} $isMobile={Target.__MOBILE__}>
        <SpinePlayerWrapper>
          <StyledSpineSplayer
            animationId={animationId}
            soundId={soundId}
            width={750}
            height={750}
            onEndAnimation={endAnimation}
            hideMuteButton
            preventCutAnim
          />
        </SpinePlayerWrapper>
      </Wrapper>
    </CSSTransition>
  );
};

export default OverlayAnimation;
